import React from 'react';
import { Card, Grid, Skeleton } from 'antd';

const { useBreakpoint } = Grid;

const AgentCardSkeletonItem = () => {
    const screens = useBreakpoint();
    const isMobile = screens?.xs;
    
    return (
        <Card
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: isMobile ? '100%' : '260px',
            }}
            bordered={false}
            styles={{
                body: {
                    padding: '20px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
            actions={[
                <Skeleton.Button active size="small" shape="circle" key="1" />,
                <Skeleton.Button active size="small" shape="circle" key="2" />,
                <Skeleton.Button active size="small" shape="circle" key="3" />,
                <Skeleton.Button active size="small" shape="circle" key="4" />
            ]}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px'
            }}>
                {/* Platform Icon/Image placeholder */}
                <Skeleton.Avatar
                    active
                    size={44}
                    style={{
                        borderRadius: '8px'
                    }}
                />

                {/* Status badge placeholder */}
                <Skeleton.Button
                    active
                    size="small"
                    style={{
                        width: '80px',
                        height: '24px',
                        borderRadius: '4px'
                    }}
                />
            </div>

            <div style={{ flex: 1, overflow: 'hidden' }}>
                {/* Platform type badge */}
                <Skeleton.Button
                    active
                    size="small"
                    style={{
                        width: '120px',
                        height: '22px',
                        marginBottom: '8px',
                        borderRadius: '4px'
                    }}
                />

                {/* Agent name */}
                <Skeleton.Input
                    active
                    style={{
                        width: '100%',
                        height: '24px',
                        marginBottom: '4px'
                    }}
                />

                {/* Page name */}
                <Skeleton.Input
                    active
                    style={{
                        width: '80%',
                        height: '20px',
                        marginBottom: '4px'
                    }}
                />

                {/* Category */}
                <Skeleton.Input
                    active
                    style={{
                        width: '60%',
                        height: '18px',
                        marginBottom: '8px'
                    }}
                />
            </div>
        </Card>
    );
};

export default AgentCardSkeletonItem; 